import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import CreateBill from './CreateBill';
import BillsManagement from './BillsManagement';
import { FileText, Plus, List } from 'lucide-react';

function BillingOverview() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Billing System</h1>
        <p className="mt-2 text-gray-600">Generate and manage bills for your services</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Link
          to="/billing/create"
          className="card hover:shadow-lg transition-shadow cursor-pointer"
        >
          <div className="flex items-center mb-4">
            <div className="bg-primary rounded-lg p-3">
              <Plus className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 ml-4">Create New Bill</h3>
          </div>
          <p className="text-gray-600">
            Generate bills for props rental and photography services with automatic calculations.
          </p>
        </Link>

        <Link
          to="/billing/manage"
          className="card hover:shadow-lg transition-shadow cursor-pointer"
        >
          <div className="flex items-center mb-4">
            <div className="bg-blue-500 rounded-lg p-3">
              <List className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 ml-4">Manage Bills</h3>
          </div>
          <p className="text-gray-600">
            View, track, and manage all bills. Update payment status and export bills.
          </p>
        </Link>
      </div>
    </div>
  );
}

export default function BillingModule() {
  const location = useLocation();

  // Navigation tabs
  const tabs = [
    { name: 'Overview', href: '/billing', icon: FileText },
    { name: 'Create Bill', href: '/billing/create', icon: Plus },
    { name: 'Manage Bills', href: '/billing/manage', icon: List }
  ];

  return (
    <div>
      {/* Navigation Tabs */}
      {location.pathname !== '/billing' && (
        <div className="mb-8">
          <nav className="flex space-x-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = location.pathname === tab.href;
              return (
                <Link
                  key={tab.name}
                  to={tab.href}
                  className={`flex items-center py-2 px-1 border-b-2 font-medium text-sm ${
                    isActive
                      ? 'border-primary text-primary'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="h-4 w-4 mr-2" />
                  {tab.name}
                </Link>
              );
            })}
          </nav>
        </div>
      )}

      {/* Routes */}
      <Routes>
        <Route path="/" element={<BillingOverview />} />
        <Route path="/create" element={<CreateBill />} />
        <Route path="/manage" element={<BillsManagement />} />
      </Routes>
    </div>
  );
}
